var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"cycle":"","height":"600","hide-delimiter-background":"","show-arrows-on-hover":"","hide-delimiters":""},scopedSlots:_vm._u([{key:"prev",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"success"}},'v-btn',attrs,false),on),[_vm._v("Previous slide ")])]}},{key:"next",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"info"}},'v-btn',attrs,false),on),[_vm._v("Next slide ")])]}}])},_vm._l((_vm.imgList),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }